import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

// Einstellungen → Vorlagen: automatische Erinnerung vor Ablauf der Zustimmungsfrist (§ 558b BGB)
export default function RentIncreaseReminderPanel() {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/rent-increase/reminder/settings").then(({ data }) => setF(data)).catch(() => setF({ enabled: true, days: 7 })); }, []);
  const save = async () => {
    try { await api.put("/rent-increase/reminder/settings", { enabled: f.enabled, days: Number(f.days) }); toast.success("Erinnerungs-Einstellungen gespeichert"); }
    catch (e) { toast.error(e?.response?.data?.detail?.[0]?.msg || e?.response?.data?.detail || "Speichern fehlgeschlagen"); }
  };
  if (!f) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-md p-4 sm:p-6 shadow-sm space-y-3" data-testid="ri-reminder-settings">
      <div className="text-sm font-semibold">Mieterhöhung – automatische Erinnerung an den Mieter</div>
      <p className="text-xs text-slate-600">
        Liegt bis kurz vor Ablauf der Zustimmungsfrist keine Antwort vor, erstellt Domivus automatisch ein Erinnerungsschreiben
        (Vorlage „Mieterhöhung – Erinnerung an die Zustimmung“) mit erneut beigefügter Rückantwort und QR-Code und legt eine Aufgabe
        zum Drucken und Versenden an. Der Text ist oben unter den Systemvorlagen bearbeitbar.
      </p>
      <div className="flex flex-wrap items-center gap-4">
        <label className="flex items-center gap-2 text-sm">
          <Switch checked={f.enabled} onCheckedChange={(v) => setF({ ...f, enabled: v })} data-testid="ri-reminder-enabled" />
          Automatisch erstellen
        </label>
        <label className="flex items-center gap-2 text-sm">
          <Input type="number" min={1} max={60} value={f.days} onChange={(e) => setF({ ...f, days: e.target.value })} className="w-20 h-8" disabled={!f.enabled} data-testid="ri-reminder-days" />
          Tage vor Fristende
        </label>
        <Button size="sm" onClick={save} data-testid="ri-reminder-save">Speichern</Button>
      </div>
    </div>
  );
}
